import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const CustomCheckbox = ({ checked, onChange }) => {
  return (
    <div 
      onClick={() => onChange(!checked)}
      style={{
        width: '22px',
        height: '22px',
        borderRadius: '6px',
        border: '2px solid rgba(251, 191, 36, 0.6)',
        background: checked ? '#fbbf24' : 'rgba(15, 23, 42, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: checked ? '0 0 10px rgba(251, 191, 36, 0.5)' : 'none',
        flexShrink: 0
      }}
    >
      {checked && (
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#0f172a" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      )}
    </div>
  );
};

export default function SettingsModal({ 
  onClose, 
  autoRoll, 
  onToggleAutoRoll, 
  autoBuy, 
  onToggleAutoBuy, 
  autoResolveCards, 
  onToggleAutoResolveCards,
  showOthersCards,
  onToggleShowOthersCards,
  soundFxEnabled,
  onToggleSoundFx
}) {
  const { lang, setLang, toggleLanguage, t } = useLanguage();

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 150000, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}>
      <div 
        className="glass-panel" 
        onClick={e => e.stopPropagation()}
        style={{
          width: '90%',
          maxWidth: '440px',
          maxHeight: '85vh',
          overflowY: 'auto',
          padding: '20px 24px',
          background: 'rgba(15, 23, 42, 0.96)',
          border: '1.5px solid rgba(251, 191, 36, 0.4)',
          borderRadius: '16px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
          color: '#fff',
          position: 'relative'
        }}
      >
        <button 
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'transparent',
            border: 'none',
            color: '#94a3b8',
            fontSize: '1.2rem',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>
        <h2 style={{ margin: '0 0 20px 0', fontSize: '1.5rem', color: '#fcd34d', fontFamily: 'Outfit, sans-serif' }}>
          {t('settings.title', '⚙️ Ayarlar')}
        </h2>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>{t('settings.language', 'Dil Seçeneği')}</div>
              <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>{lang === 'tr' ? 'Türkçe 🇹🇷' : 'English 🇬🇧'}</div>
            </div>
            <button
              onClick={toggleLanguage}
              style={{
                background: 'linear-gradient(135deg, #0284c7, #0369a1)',
                border: '1px solid #38bdf8',
                borderRadius: '8px',
                padding: '6px 14px',
                color: '#fff',
                fontWeight: 700,
                fontSize: '0.85rem',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(3, 105, 161, 0.4)'
              }}
            >
              {lang === 'tr' ? '🇬🇧 English' : '🇹🇷 Türkçe'}
            </button>
          </div>

          <div style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}></div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>Otomatik Zar At</div>
              <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Sıra size geldiğinde zarları bekletmeden atar.</div>
            </div>
            <CustomCheckbox checked={autoRoll} onChange={onToggleAutoRoll} />
          </div>
          
          <div style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}></div>
          
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>Otomatik Satın Al</div>
              <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Sahipsiz bir mülke geldiğinizde otomatik olarak satın alır.</div>
            </div>
            <CustomCheckbox checked={autoBuy} onChange={onToggleAutoBuy} />
          </div>

          <div style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}></div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>Otomatik Kart Tamamla</div>
              <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Şans ve Kamu Fonu kartlarını çektiğinizde bekletmeden onaylar.</div>
            </div>
            <CustomCheckbox checked={autoResolveCards} onChange={onToggleAutoResolveCards} />
          </div>

          <div style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}></div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>Diğer Oyuncuların Kartlarını Göster</div>
              <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Diğer oyuncuların çektiği şans/mülk kartı pencerelerini ekrana getirir.</div>
            </div>
            <CustomCheckbox checked={showOthersCards} onChange={onToggleShowOthersCards} />
          </div>

          <div style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}></div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>Ses Efektleri (Sound FX)</div>
              <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Zar atma, hareket ve diğer oyun seslerini açar/kapatır.</div>
            </div>
            <CustomCheckbox checked={soundFxEnabled} onChange={onToggleSoundFx} />
          </div>
        </div>
      </div>
    </div>
  );
}
